import React from 'react';
import { Link } from 'react-router-dom';
import '../index.css';

function ThankYouFeedback() {
    return (
        <div className="thank-you-container">
            <div className="thank-you-content">
                <img 
                    src={`${process.env.PUBLIC_URL}/assets/images/thankyou.jpg`} 
                    alt="Penguin" 
                    className="thankyou-img" 
                />
                <h1>Thank You</h1>
                <h2>Your data is successfully submitted</h2>
                <Link to="/" className="view-home-button">
                    <button className="thankyou-home-button">View Home Page</button>
                </Link>
            </div>
        </div>
    );
}

export default ThankYouFeedback;
